import script from "./MainSidebarNavList.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebarNavList.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebarNavList.vue?vue&type=style&index=0&id=2e15cd27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e15cd27"]])

export default __exports__